// extracted by mini-css-extract-plugin
export var brand = "_82-9";
export var compact = "_82-6";
export var extraSmall = "_82-7";
export var icon = "_82-0";
export var large = "_82-4";
export var light = "_82-1";
export var medium = "_82-5";
export var outline = "_82-b";
export var primaryDark = "_82-a";
export var primaryLight = "_82-8";
export var primaryModern = "_82-c";
export var success = "_82-2";
export var successSolid = "_82-3";